<template>
  <div>
    <template v-for="(input, index) in value">
      <div class="items_group" :key="index">
        <div class="remove_items">
          <button v-if="index !== 0" @click="handleRemoveArray(index)">
            <span
              ><font-awesome-icon icon="times" size="2x"></font-awesome-icon
            ></span>
          </button>
        </div>

        <atoms-input-textarea
          :label="`時期`"
          placeholder="時期"
          :required="false"
          v-model="input.season"
          :setKey="`season-${index}`"
          @input-emit="handleUpdateArrayValue"
        ></atoms-input-textarea>

        <atoms-input-textarea
          :label="`病名`"
          placeholder="病名"
          :required="false"
          v-model="input.diseaseName"
          :setKey="`diseaseName-${index}`"
          @input-emit="handleUpdateArrayValue"
        ></atoms-input-textarea>

        <atoms-input-textarea
          :label="`医療機関\n現在の主治医はTEL・往診の有無`"
          placeholder="医療機関など"
          :required="false"
          v-model="input.medicalInstitution"
          :setKey="`medicalInstitution-${index}`"
          @input-emit="handleUpdateArrayValue"
        ></atoms-input-textarea>

        <div class="d-flex align-items-end">
          <atoms-input-text
            label="回数"
            type="text"
            inputmode="text"
            placeholder="回数"
            :required="false"
            v-model="input.supportCount"
            :setKey="`supportCount-${index}`"
            widthClassName="w-smallest"
            @input-emit="handleUpdateArrayValue"
          ></atoms-input-text>
          <p class="u-ml5 u-mb0">回</p>
        </div>
      </div>
    </template>
    <div class="add_items" v-if="currentMaxIndex < dataMax">
      <button @click="handleAddArray()">
        <span
          ><font-awesome-icon icon="plus-circle" size="2x"></font-awesome-icon
        ></span>
        既往・現病歴を追加する
      </button>
    </div>
  </div>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    setArrayKey: {
      type: String,
      required: true,
    },
    dataMax: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      currentMaxIndex: 0,
      useDefine: { defineObject: defineObject },
      baseObj: {
        season: '',
        diseaseName: '',
        medicalInstitution: '',
        supportCount: '',
      }
    }
  },
  methods: {
    handleAddArray() {
      this.currentMaxIndex++
      this.$emit('add-array', this.setArrayKey, {
        season: '',
        diseaseName: '',
        medicalInstitution: '',
        supportCount: '',
      })
    },
    handleRemoveArray(index) {
      this.currentMaxIndex--
      this.$emit('remove-array', this.setArrayKey, index)
    },
    handleUpdateArrayValue(setKey, setValue) {
      if (setKey && setValue) {
        const setKeyArray = setKey.split('-')
        this.$emit(
          'input-emit',
          this.setArrayKey,
          setKeyArray[0],
          setKeyArray[1],
          setValue
        )
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.value.length === 0) {
        this.handleAddArray()
      } else {
        this.value.forEach(item => {
          Object.keys(this.baseObj).forEach(key => {
            if (!item[key]) {
              item[key] = ''
            }
          })
        })
      }
      this.currentMaxIndex = this.value.length
    })
  },
}
</script>
